export const ROLES = {
  OWNER: "Owner",
  ADMIN: "Admin",
  MODERATOR: "Moderator",
  VIEWER: "Viewer",
};

/** Admin panel login access (orders / analytics / tools depending on role). */
export function canAccessPanel(role) {
  return (
    role === ROLES.OWNER ||
    role === ROLES.ADMIN ||
    role === ROLES.MODERATOR ||
    role === ROLES.VIEWER
  );
}

export function canViewOrders(role) {
  return canAccessPanel(role);
}

/** Sales analytics dashboard — Owner, and Viewer (marketing). */
export function canViewAnalytics(role) {
  return role === ROLES.OWNER || role === ROLES.VIEWER;
}

/** Checkout customer data — Owner, Admin, and Viewer (marketing). */
export function canViewCustomerAnalytics(role) {
  return isAdmin(role) || role === ROLES.VIEWER;
}

/** Totals / amounts on dashboard summary cards — Owner only. */
export function canViewFinancials(role) {
  return role === ROLES.OWNER;
}

export function isOwner(role) {
  return role === ROLES.OWNER;
}

/** Owner has the same operational tools as Admin. */
export function isAdmin(role) {
  return role === ROLES.ADMIN || role === ROLES.OWNER;
}

/** Status changes, WhatsApp, delete, print queue, etc. */
export function canMutateOrders(role) {
  return isAdmin(role) || role === ROLES.MODERATOR;
}

/** Order activity history. Viewer can read it; only the Owner can export or restore. */
export function canViewOrderActivity(role) {
  return canViewOrders(role);
}

export function canExportOrderActivity(role) {
  return isOwner(role);
}

export function canRestoreOrderActivity(role) {
  return isOwner(role);
}

/** Tickets are an operational tool: Owner, Admin, and Moderator. Viewer is excluded. */
export function canViewTickets(role) {
  return isAdmin(role) || role === ROLES.MODERATOR;
}

export function canViewReturns(role) {
  return isAdmin(role) || role === ROLES.MODERATOR;
}

export function canMutateReturns(role) {
  return isAdmin(role) || role === ROLES.MODERATOR;
}

export function canDeleteAllReturns(role) {
  return isAdmin(role);
}

export function canCreateTickets(role) {
  return isAdmin(role) || role === ROLES.MODERATOR;
}

export function canEditTickets(role) {
  return isAdmin(role) || role === ROLES.MODERATOR;
}

export function canChangeTicketStatus(role) {
  return isAdmin(role) || role === ROLES.MODERATOR;
}

export function canAssignTickets(role) {
  return isAdmin(role) || role === ROLES.MODERATOR;
}

export function canManageTicketProblemTypes(role) {
  return isAdmin(role);
}

export function canCloseTickets(role) {
  return isAdmin(role) || role === ROLES.MODERATOR;
}

export function canDeleteTickets(role) {
  return isAdmin(role) || role === ROLES.MODERATOR;
}

export function isViewer(role) {
  return role === ROLES.VIEWER;
}

export function getRoleLabel(role, { short = false } = {}) {
  switch (role) {
    case ROLES.OWNER:
      return short ? "مالك" : "المالك";
    case ROLES.ADMIN:
      return short ? "مدير" : "مدير النظام";
    case ROLES.MODERATOR:
      return short ? "مشرف" : "مشرف";
    case ROLES.VIEWER:
      return short ? "متفرج" : "متفرج (عرض فقط)";
    default:
      return role || "";
  }
}
